module.exports = __webpack_public_path__ + "img/more-vertical.eb39c5b4.svg";